<template>
    <div>
        <div class="container-fluid">
            <div class="row">
                <div class="col-12">
                    <el-tabs v-model="activeTab">

                        <el-tab-pane name="mv" label="Mass Vaccination">
                            <div v-if="activeTab === 'mv'" class="row">
                                <div class="col-12 dogs-col">
                                    <ProjectSection
                                        title="Mass Vaccination"
                                        :report="report.mv_projects"
                                        :kmlUrls="kmlUrlList1"
                                        mapRefId="mvMapRef"
                                        :markers="mvMarkers"
                                        :isDataLoaded="isDataLoaded"
                                    />
                                </div>
                            </div>
                        </el-tab-pane>

                        <el-tab-pane name="pm" label="Population Management (spay neuter)">
                            <div v-if="activeTab === 'pm'" class="row">
                                <div class="col-12 manag-col">
                                    <ProjectSection
                                        title="Population Management (spay neuter)"
                                        :report="report.pm_projects"
                                        :kmlUrls="kmlUrlList2"
                                        mapRefId="pmMapRef"
                                        :markers="pmMarkers"
                                    />
                                </div>
                            </div>
                        </el-tab-pane>

                        <el-tab-pane name="hc" label="Health Clinic">
                            <div v-if="activeTab === 'hc'" class="row">
                                <div class="col-12 manag-col">
                                    <ProjectSection
                                        title="Health Clinic"
                                        :kmlUrls="[]"
                                        :report="report.hc_projects"
                                        mapRefId="hcMapDashLocation"
                                        :markers="hcMarkers"
                                    />
                                </div>
                            </div>
                        </el-tab-pane>

                    </el-tabs>
                </div>

            </div>
        </div>
    </div>
</template>

<script>
import ProjectSection from './ProjectSection.vue';
import {Tabs, TabPane} from "element-ui";

export default {
    components: {
        ProjectSection,
        [Tabs.name]: Tabs,
        [TabPane.name]: TabPane,
    },
    data() {
        return {
            pos: {lat: 20.7374838, lng: 72.1133452},
            report: {
                mv_projects: {...defaultProjectData},
                pm_projects: {...defaultProjectData},
                hc_projects: {
                    total_dewormings: 0,
                    total_female: 0,
                    total_male: 0,
                    total_not_owned: 0,
                    total_owned: 0,
                    total_sterilized: 0,
                    total_treatments: 0,
                    total_unsterilized: 0,
                    projects: []
                }
            },
            kmlUrlList1: [],
            kmlUrlList2: [],
            mvMap: null,
            pmMap: null,
            hcMap: null,
            organisationId: null,
            mvMarkers: [],
            pmMarkers: [],
            hcMarkers: [],
            isDataLoaded: false,
            activeTab: ''
        }
    },
    methods: {
        init() {
            this.getOrgReport();
        },
        getMvPoints() {
            const vm = this;
            vm.report.mv_projects.projects.forEach(project => {
                project.data.record_location_points.forEach(point => {
                    const [lat, lng] = point.split(",").map(parseFloat);
                    vm.mvMarkers.push({lat, lng});
                });
            });
        },
        getPmPoints() {
            const vm = this;
            vm.report.pm_projects.projects.forEach(project => {
                project.data.record_location_points.forEach(point => {
                    const [lat, lng] = point.split(",").map(parseFloat);
                    vm.pmMarkers.push({lat, lng});
                });
            });
        },
        getHcProjectLocation() {
            const vm = this;
            vm.report.hc_projects.projects.forEach((project) => {
                const [lat, lng] = project.project_location.split(",").map(parseFloat);
                vm.hcMarkers.push({lat, lng})
            });
        },
        getOrgReport() {
            const vm = this;
            const loading = this.$loading({
                lock: true,
                text: 'Loading...',
                spinner: 'el-icon-loading',
                background: 'rgba(0, 0, 0, 0.7)'
            });
            vm.organisationId = vm.$store.getters['user/organisation'].id;
            window.axios.get(`organisation/generate/report/overview/${vm.organisationId}`)
                .then(response => {
                    if (response.data.response.error.error_code === 0) {
                        const data = response.data.response.data;
                        vm.report = data.org_overview;
                        vm.kmlUrlList1.push(...vm.extractKmlUrls(vm.report.mv_projects.projects));
                        vm.kmlUrlList2.push(...vm.extractKmlUrls(vm.report.pm_projects.projects));
                        vm.getMvPoints();
                        vm.getPmPoints();
                        vm.getHcProjectLocation();
                        vm.activeTab = 'mv';
                    }
                })
                .catch(e => {
                    console.log(e)
                })
                .finally(() => {
                    loading.close()
                })

        },
        extractKmlUrls(projects) {
            return projects.flatMap(project => project.data.areas.map(area => area.file_url));
        }
    },
    mounted() {
        this.init();
        if (navigator.geolocation) {
            navigator.geolocation.getCurrentPosition(
                position => this.pos = {lat: position.coords.latitude, lng: position.coords.longitude},
                () => alert("Current location not allowed or is disabled")
            );
        }
    }
}

const defaultProjectData = {
    total_projects: 0,
    total_vaccinations: 0,
    total_male: 0,
    total_female: 0,
    area_surveyed: 0,
    avg_treated_per_day: 0,
    vaccination_rate_based_on_survey: 0,
    projects: []
};
</script>

<style scoped>
.save_all_dogs_main {

@media (max-width: 1200px) {
    .row {
        margin-left: -10px;
        margin-right: -10px;

    .col-sm-6, .col-6, .col-12 {
        padding-left: 10px;
        padding-right: 10px;
    }
}

}
@media (max-width: 900px) {
    .container-fluid {
        padding: 0;
    }
}

@media (max-width: 600px) {
    .dogs-col, .manag-col {
        flex: 0 0 100%;
        max-width: 100%;
    }
}

@media (max-width: 400px) {
    .dogs-col, .manag-col {

    .col-md-3 {
        flex: 0 0 100%;
        max-width: 100%;
    }
}

}
}
</style>
